import { gql } from '@apollo/client';
import CLASSROOM_USER_ENROLLMENT_FRAGMENT from 'graph/fragments/classroom-user-enrollment';

const CLASSROOM_FRAGMENT = gql`
  fragment BASE_CLASSROOM_FRAGMENT on Classroom {
    id
    name
    studentCount
    color
    dateArchived
    organization {
      id
      name
    }
    users {
      ...BaseClassroomUserEnrollment
    }
    licenseUsage {
      assignedCount
      product {
        id
        name
        code
        iconUrl
      }
      productCurriculum {
        id
        code
        name
        gradeLevel
        trialAvailable
        iconUrl
        bannerUrl
      }
    }
  }
  ${CLASSROOM_USER_ENROLLMENT_FRAGMENT}
`;

const GET_CLASSROOMS_MANAGEMENT_QUERY = gql`
  query getOrganizationClassrooms {
    organizations {
      id
      name
      classrooms {
        ...BASE_CLASSROOM_FRAGMENT
      }
    }
    users {
      id
      firstName
      lastName
    }
  }
  ${CLASSROOM_FRAGMENT}
`;

export default GET_CLASSROOMS_MANAGEMENT_QUERY;
